var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPadlockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 328,
    viewBox: "0 0 251 328",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.958 0C71.0669 0 26.5685 44.4984 26.5685 99.3899V141.077H13.7405C6.15185 141.077 0 147.229 0 154.817V314.208C0 321.797 6.15185 327.948 13.7405 327.948H236.337C243.926 327.948 250.078 321.797 250.078 314.208V154.817C250.078 147.229 243.926 141.077 236.337 141.077H225.348V99.3899C225.348 44.4984 180.85 0 125.958 0ZM61.3717 101.685V141.077H191.449V101.685C191.449 65.7655 162.33 36.6467 126.41 36.6467C90.4904 36.6467 61.3717 65.7655 61.3717 101.685ZM153.89 203.376C153.89 214.198 147.836 223.606 138.93 228.399L144.726 281.246H106.253L111.726 228.219C103.001 223.373 97.0961 214.064 97.0961 203.376C97.0961 187.692 109.81 174.979 125.493 174.979C141.177 174.979 153.89 187.692 153.89 203.376Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockIcon);
export default __webpack_public_path__ + "static/media/padlock-icon.bfa0a3d5.svg";
export { ForwardRef as ReactComponent };